module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraphPage",
    attrs: {
      "id": "epi01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphText"
  }, [_vm._v("“If you bring forth what is within you, what you bring forth will save you. If you do not bring forth what is within you, what you do not bring forth will destroy you.”")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSource"
  }, [_vm._v("—T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OSPEL OF")]), _vm._v(" T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HOMAS")]), _vm._v(", V"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ERSE")]), _vm._v(" 70")])])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dbf07d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416995050_epi01.vue
// module id = 75
// module chunks = 0